/**
 * Project Row Priority Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.projectRowPriorityFormatter = function(value, row) {
    let html = '';
    if (value) {
        switch (value) {
            case 'low':
                // Do Nothing
                break;
            case 'normal':
                // Do Nothing
                break;
            case 'high':
                // Do Nothing
                break;
            case 'urgent':
                html += '<i class="fas fa-circle-exclamation text-danger"></i>';
                break;
        }
    }
    return html;
};
